'use strict';

// Adyen supplied constants (should match cartridges/app_adyen_SFRA/cartridge/client/default/js/constants.js)
const constants = {
    METHOD_ADYEN: 'Adyen',
    METHOD_ADYEN_POS: 'AdyenPOS',
    METHOD_ADYEN_COMPONENT: 'AdyenComponent',
    RECEIVED: 'Received',
    NOTENOUGHBALANCE: 'NotEnoughBalance',
    SUCCESS: 'Success',
    GIFTCARD: 'giftcard',
    SCHEME: 'scheme',
    GIROPAY: 'giropay',
    APPLE_PAY: 'applepay',
    PAYPAL: 'paypal',
    AMAZON_PAY: 'amazonpay',
    ACTIONTYPE: {
        QRCODE: 'qrCode'
    },
    DISABLED_SUBMIT_BUTTON_METHODS: [
        'paypal',
        'paywithgoogle',
        'googlepay',
        'amazonpay',
        'applepay',
        'cashapp',
        'upi'
    ]
};

/**
 * Additional customizations supplied by CSC
 */
// We added the CREDIT_CARD constant before Adyen added the SCHEME constant. Choosing to keep the original we added, as it is more clear that the "credit card" payment is mapped to "scheme"
constants.CREDIT_CARD = constants.SCHEME;
constants.FIRST_PAYMENT_TO_SHOW = constants.CREDIT_CARD;
constants.KLARNA = 'klarna';
constants.DISABLED_SUBMIT_BUTTON_METHODS.push('klarna');

module.exports = constants;
